import axios from "axios";
import { Constants } from "../Constants";

const instance = axios.create({ baseURL: Constants.BASE_URL });

export const addProperty = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.post(
      `${Constants.BASE_URL}properties`,
      data,
      httpOptions
    );
  } catch (error) {
    throw error;
  }
};

export const editProperty = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.put(
      `${Constants.BASE_URL}properties/${data.id}`,
      data,
      httpOptions
    );
  } catch (error) {
    throw error;
  }
};

export const getProperty = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(
      `${Constants.BASE_URL}properties/${data.id}`,
      httpOptions
    );
  } catch (error) {
    throw error;
  }
};

export const getProperties = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`properties?page=${data.page}`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const deleteProperty = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.delete(
      `${Constants.BASE_URL}properties/${data.id}`,
      httpOptions
    );
  } catch (error) {
    throw error;
  }
};

export const disableProperty = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.delete(
      `${Constants.BASE_URL}properties/disable/${data.id}`,
      httpOptions
    );
  } catch (error) {
    throw error;
  }
};

export const uploadImageProperty = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await axios.post(
      `${Constants.BASE_URL}properties/image_upload`,
      data,
      httpOptions
    );
  } catch (error) {
    throw error;
  }
};
